(() => {
  if (!document.body.classList.contains('rdb-product-d2')) return;
  const refresh = () => {
    if (document.documentElement.lang.split('-')[0] === 'ar') {
      const title = document.querySelector('.product-information h1');
      if (title && !title.childElementCount) {
        const parts = title.textContent.match(/^([\s\S]*?)(\([A-Za-z][^()]*\))(\s*)$/);
        if (parts && /[\u0600-\u06ff]/.test(parts[1])) {
          const name = document.createElement('bdi');
          name.className = 'rp-product-latin-name';
          name.dir = 'ltr';
          name.textContent = parts[2];
          title.replaceChildren(document.createTextNode(parts[1]), name, document.createTextNode(parts[3]));
        }
      }
    }
    const form = document.querySelector('.product-information form[data-type="add-to-cart-form"]');
    if (!form) return;
    const cardSummary = form.querySelector('[data-premium-card-summary]');
    const nativeCardSummary = form.querySelector('p[data-card-summary]');
    if (cardSummary && nativeCardSummary && cardSummary.textContent !== nativeCardSummary.textContent) cardSummary.textContent = nativeCardSummary.textContent;
    const extrasSummary = form.querySelector('[data-premium-extras-summary]');
    if (extrasSummary) {
      extrasSummary.dataset.defaultLabel ||= extrasSummary.textContent;
      const selected = [...form.querySelectorAll('[data-extra-id][aria-pressed="true"]')].map(item => `${item.dataset.extraQuantity || 1} × ${item.dataset.extraTitle}`);
      const label = selected.length ? selected.join(' · ') : extrasSummary.dataset.defaultLabel;
      if (extrasSummary.textContent !== label) extrasSummary.textContent = label;
    }
  };
  let frame;
  const schedule = () => { if (!frame) frame = requestAnimationFrame(() => { frame = null; refresh(); }); };
  const information = document.querySelector('.product-information');
  if (information) new MutationObserver(schedule).observe(information, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-pressed','data-extra-quantity','checked']});
  for (const event of ['change','input','variant:update','rdb:currencychange']) document.addEventListener(event,schedule);
  document.addEventListener('click', event => {
    if (event.target.closest('[data-sticky-extras]')) {
      const disclosure = document.querySelector('[data-premium-extras]');
      if (disclosure) disclosure.open = true;
    }
  },true);
  refresh();
})();
